import { useEffect, useRef } from "react";

export default function ForexTicker() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    containerRef.current.innerHTML = "";

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbols: [
        { proName: "FX:EURUSD", title: "EUR / USD" },
        { proName: "FX:GBPUSD", title: "GBP / USD" },
        { proName: "FX:USDJPY", title: "USD / JPY" },
        { proName: "FX:AUDUSD", title: "AUD / USD" },
        { proName: "FX:USDCHF", title: "USD / CHF" },
      ],
      showSymbolLogo: true,
      isTransparent: true,
      displayMode: "adaptive",
      colorTheme: "dark",
      locale: "en",
    });

    containerRef.current.appendChild(script);
  }, []);

  return <div ref={containerRef} className="rounded-xl overflow-hidden" />;
}